module.exports = __webpack_public_path__ + "static/media/Communities.0e003bac.svg";